import React, { useContext } from "react";
import error from "../../assets/images/eInfo.png";
import logo from "../../assets/images/logo.png";
import { getPlatform } from "../../utils";
import { VersionContext } from "../../context";
import { useNavigate } from "react-router-dom";

import "./index.css";

const Error = () => {
  const platform = getPlatform();
  const { appVersionData } = useContext(VersionContext);
  const info = appVersionData[`${platform.toLocaleLowerCase()}VersionInfo`];
  const navigate = useNavigate();

  if (info) {
    navigate("/");
    return null
  }

  return (
    <div className="errorPage">
      <div className="errorInfo">
        <img className="errorimg" src={error} alt="error" />
        <p className="errortext">当前无可用安装包</p>
      </div>
      <div className="errorInfoCenter">
        <img className="logo" src={logo}></img>
        <p className="errorInfoCenter-text">喜茶门店通{platform}客户端</p>
        {/* <p className="errorInfoCenter-text2">
          立即下载，享受高效愉悦的办公工具
        </p> */}
      </div>
      <div className="errorInfoBottom">
        <p className="errorInfoBottom-text">开发者：深圳灵感之茶科技有限公司</p>
      </div>
    </div>
  );
};

export default Error;
